import { useEffect } from "react";

//
//component
//redux
//selector
//actions
const TriggerAudioUrl = ({ audioFile, setAudioUrl, setAudioDuration }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    console.log({ audioFile });
    if (audioFile?.file) {
      const objectUrl = URL.createObjectURL(audioFile.file);
      setAudioUrl(objectUrl);

      const audio = new Audio(objectUrl);
      audio.onloadedmetadata = () => {
        if (setAudioDuration) {
          setAudioDuration(audio.duration);
        }
      };

      return () => {
        URL.revokeObjectURL(objectUrl);
        setAudioUrl(null);
      };
    }
  }, [audioFile, setAudioUrl, setAudioDuration]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerAudioUrl;
